import React from 'react'

function Error({ message }) {
  return (
    <div className="text-center">
      <h1>{message}</h1>
    </div>
  )
}

export default Error
